import { createFileRoute } from '@tanstack/react-router';
import { HrDashboard } from '@/features/workforce/HrDashboard';

export const Route = createFileRoute('/_app/workforce/dashboard')({ component: HrDashboard });
